export class Portali {
    id: number = null;
    portale: string = null;
    wp_db_prefix: string = null;
    userAdministrator = false;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/portali.ts